// extracted by mini-css-extract-plugin
export default {"PfsHuang":"PFSHuang_PfsHuang__aOvBt","content":"PFSHuang_content__1a3Z0","homeBtn":"PFSHuang_homeBtn__IOwh2","logo":"PFSHuang_logo__IS7ek"};